import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/Home.vue";
import LogOut from "@/views/LogOut.vue";
import Login from "@/views/LogIn.vue";
import UserManagement from "@/views/UserManagement.vue";
import GapManagement from "@/views/GapManagement.vue";
import TrueWriting from "@/views/TrueWriting.vue";
import User from "@/components/gap/create-user.vue";

import LNRecruitingHome from "@/views/LNRecruitingHome.vue";
import LNCreateEditUser from "@/components/ln-recruiting/create-edit-user.vue";

import NotAuthorized from "@/views/NotAuthorized.vue";
import NotFound from "@/views/NotFound.vue";

import { Auth } from "aws-amplify";
import store from "@/store.js";
import recognizedRoles from "@/roles.js";
import UnAuthenticated from "@/views/UnAuthenticated.vue";
// import SecurityManager from "@/views/SecurityManager.vue";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "/usermanagement",
      name: "User Management",
      component: UserManagement
    },
    {
      path: "/gap",
      name: "GAP Management",
      component: GapManagement
    },
    {
      path: "/truewriting",
      name: "True Writing",
      component: TrueWriting
    },
    {
      path: "/user",
      name: "User",
      component: User,
      props: true
    },
    {
      path: "/recruiting",
      name: "Recruiting",
      component: LNRecruitingHome
    },
    {
      path: "/recruiting-user",
      name: "RecruitingUser",
      component: LNCreateEditUser,
      props: true
    },
    {
      path: "/login",
      name: "LogIn",
      component: Login
    },
    {
      path: "/office",
      name: "Office",
      component: () =>
        import(
          /* webpackChunkName: "hierarchy" */ "@/components/swimlanes-shell.vue"
        ),
      meta: {
        authorize: [
          recognizedRoles.roles.HomeOfficeReadOnly,
          recognizedRoles.roles.HomeOfficeReadWrite,
          recognizedRoles.roles.Agency
        ]
      }
    },
    {
      path: "/hierarchy",
      name: "Hierarchy",
      component: () =>
        import(/* webpackChunkName: "hierarchy" */ "@/views/Hierarchy.vue"),
      meta: {
        authorize: [
          recognizedRoles.roles.HomeOfficeReadOnly,
          recognizedRoles.roles.HomeOfficeReadWrite,
          recognizedRoles.roles.Agency
        ]
      }
    },
    {
      path: "/agency",
      name: "Agency",
      component: () =>
        import(/* webpackChunkName: "agencyAddress" */ "@/views/Agency.vue"),
      meta: {
        authorize: [
          recognizedRoles.roles.HomeOfficeReadWrite,
          recognizedRoles.roles.Agency
        ]
      }
    },
    {
      path: "/history",
      name: "History",
      component: () =>
        import(/* webpackChunkName: "history" */ "@/views/History.vue"),
      meta: {
        authorize: [
          recognizedRoles.roles.HomeOfficeReadOnly,
          recognizedRoles.roles.HomeOfficeReadWrite
        ]
      }
    },
    {
      path: "/replace",
      name: "Replace",
      component: () =>
        import(
          /* webpackChunkName: "replace-ao" */ "@/components/replace-ao.vue"
        ),
      meta: {
        authorize: [recognizedRoles.roles.HomeOfficeReadWrite]
      }
    },
    {
      path: "/logout",
      name: "LogOut",
      component: LogOut
    },

    {
      path: "/notauthorized",
      name: "Access Denied",
      component: NotAuthorized
    },
    {
      path: "/unauthenticated",
      name: "Authentication Error",
      component: UnAuthenticated
    },
    {
      path: "*",
      name: "Not Found",
      component: NotFound
    }
    // {
    //   path: "/lnladmin",
    //   name: "LNL Admin",
    //   component: SecurityManager,
    //   meta: {
    //     authorize: [recognizedRoles.roles.LNLAdmin]
    //   }
    // }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

export default router;

router.beforeEach(async (to, from, next) => {
  const { authorize } = to.meta;

  if (to.query.accesscode && to.path == "/") {
    store.commit("setAccessCode", to.query.accesscode);
    window.sessionStorage.setItem("accessCode", to.query.accesscode);
    return next();
  } else {
    if (
      to.query.error_description &&
      to.query.error_description ==
        "Invalid SAML response received: Invalid ProviderName/Username combination. Please check again "
    ) {
      return next({
        path: "/login",
        query: {
          code: from.query.code ? from.query.code : to.query.code,
          checkname: "true"
        }
      });
    }

    try {
      Auth.currentAuthenticatedUser()
        .then(user => {
          let authorized = false;
          if (!authorize || !authorize.length) {
            authorized = true;
          }
          try {
            if (store.state.userRoles && store.state.userRoles.length) {
              let roles = store.state.userRoles.split(",");

              for (let role of roles) {
                if (authorize && authorize.length && authorize.includes(role)) {
                  authorized = true;
                }
              }
            }

            if (!user || !authorized) {
              // role not authorised so redirect to home page
              return next({
                path: "/notauthorized",
                query: {
                  // login: to.query.login ? to.query.login : "",
                  // accesscode: to.query.accesscode,
                }
              });
            }
          } catch (e) {
            console.log("router authenticateduser catch");
            console.log(e);
          }
        })
        .catch(e => {
          console.log("router");
          console.log(e);

          if (authorize && to.path != "/") {
            // not logged in so redirect to login page with the return url
            // and the login query if it exists:
            return next({
              path: "/login",
              query: {
                code: from.query.code ? from.query.code : to.query.code,
                unauthorized: from.query.unauthorized
                  ? from.query.unauthorized
                  : to.query.unauthorized,
                unauthenticated: true
              }
            });
          }
        });
    } catch (e) {
      console.log("router beforeEact authentication catch");
      console.log(e);
    }
    return next({
      query: {
        code: from.query.code ? from.query.code : to.query.code
        // accesscode: to.query.accesscode,
      }
    });
  }
});
